
import CryptoJS from 'crypto-js'
export const encrypt = (data, keyStr) => {
  keyStr = keyStr.slice(0, 16)
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  // 加密obj
  let obj = CryptoJS.AES.encrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
  return obj
}
